export const config = {
  apiKey: "AIzaSyBeGpDhAab3Glb3KmtwemXNaToQK_3DBF8",
  authDomain: "mksys-87fd8.firebaseapp.com",
  projectId: "mksys-87fd8",
  storageBucket: "mksys-87fd8.firebasestorage.app",
  messagingSenderId: "313237771208",
  appId: "1:313237771208:web:3734f9dabf31a4a9ebe6fd",
  measurementId: "G-MPYJLQMKHZ"
};